var Curriculog = Curriculog || {};

Curriculog.UserImportFlyout = (function ($, _, Backbone, UserImportFlyout) {

    UserImportFlyout = Curriculog.CurriculogView.extend({
        el: function() {
            return $('#curriculog-summary-column');
        },

        events: {
            'click #import-users-btn': 'begin',
            'change #csv_file': 'onFileChange',
            'click #user-import-submit': 'submit'
        },

        initialize: function(options) {
            this.valid_headers = ['firstname', 'lastname', 'email', 'username', 'password', ''];
            this.req_headers = ['firstname', 'lastname', 'email', 'password'];
            this.existing_users = [];
            this.doneLoading = false;
            this.params = options.params;
            this.getExistingUsers().done(_.bind(function() {
                this.doneLoading = true;
                this.parseFile();
            }, this));
            this.config = {
                skipEmptyLines: true,
                step: _.bind(this.parserStep, this),
                complete: _.bind(this.parserComplete, this),
            };
        },

        begin: function() {
            this.inputChanged = false;
            this.headers = [];
            this.user_rows = [];
            this.render();
            this.promptFile();
        },

        render: function() {
            var html = nunjucks.render('Settings/userImport.html', {
              cui_enabled: this.params.cui_enabled
            });
            this.$el.html(html);
            this.$input = this.$('#csv_file');
            this.$('#import-loading-users').hide();
            this.$('#user-import-parsing').hide();
            this.$('#user-import-save-status').hide();
            this.undelegateEvents();
            this.delegateEvents();
        },

        promptFile: function() {
            this.$input.click();
        },

        onFileChange: function() {
            this.inputChanged = true;
            this.parseFile();
        },

        parseFile: function() {
            if ( !this.doneLoading || !this.inputChanged ) {
                return;
            }

            this.inputChanged = false;
            this.$('#user-import-parsing').show();
            this.$('#user-import-save-status').hide();

            _.each(this.user_rows, function(row) {
                row.remove();
            });

            this.headers = [];
            this.user_rows = [];

            Papa.parse(this.$input[0].files[0], this.config)
        },

        parserComplete: function(result, parser) {
            this.$('#user-import-parsing').hide();
            _.each(this.user_rows, function(row) {
                row.recheck();
            });
        },

        parserStep: function(result, parser) {
            if (!this.headers.length) {
                return this.parseHeaders(result, parser);
            }
            return this.parseRow(result, parser);
        },

        parseHeaders: function(result, parser) {
            var msg = '';
            var bad_headers = [];
            this.headers = _.map(result.data[0], function(item){
                item = item.replace(/[\s_-]/g, '').toLowerCase().trim();
                if(!this.valid_headers.includes(item) || this.containsUnicode(item)) {
                    bad_headers.push(item);
                }
                return item;
            }, this);

            if (bad_headers.length) {
                msg = 'Invalid headers: ' + bad_headers.join(',');
                new Curriculog.SimpleWarningDialog({message: msg});
                parser.abort();
            }

            if (this.req_headers.length !== _.intersection(this.headers, this.req_headers).length) {
                 msg = "Missing one or more required columns:\n" + this.req_headers.join(', ');
                new Curriculog.SimpleWarningDialog({message: msg});
                parser.abort();
            }
        },

        parseRow: function(result, parser) {
            var data = result.data[0];
            var user_row = {
              has_unicode: [],
              params: this.params
            };

            _.map(data, function(item, index) {
                var field_name = this.headers[index];
                // if the column isnt empty
                if (field_name.length) {
                    user_row[field_name] = item.trim();
                }
            }, this);

            var row = new Curriculog.UserImportRow(user_row, this);
            this.$('#user-import-list tbody').append(row.$el);
            this.user_rows.push(row);
        },

        deleteRow: function(row) {
            this.user_rows = _.without(this.user_rows, row);
            row.remove();
            _.each(this.user_rows, function(row) {
                row.recheck();
            });
            this.onRowChange();
        },

        containsUnicode: function(string) {
            var ascii = /^[ -~]+$/;
            return string !== '' && !ascii.test(string);
        },

        isExisting: function(query_obj) {
            if (typeof _.findWhere(this.existing_users, query_obj) !== 'undefined') {
                return true;
            }
            return false;
        },

        isDuplicate: function(query_obj) {
            var models = _.pluck(this.user_rows, 'model');
            if (_.where(models, query_obj).length > 1) {
                return true;
            }
            return false;
        },

        submit: function() {
            if (this.$('#user-import-submit').attr('disabled')) {
                new Curriculog.SimpleWarningDialog({message: 'Please fix all errors before submitting'});
                return;
            }

            if (!this.user_rows.length) {
                new Curriculog.SimpleWarningDialog({message: 'No users to save'});
                return;
            }

            // Hide the user list to reduce redraws
            this.$('.user-import-row').hide();
            dom().verticalStretchList();

            // Disable submit
            this.$('#user-import-submit').attr('disabled', "disabled");

            // Mask the table
            this.addMask(this.$('#user-import-summary'), 'Creating users');

            this.submitNextRow(this.user_rows.slice());
        },

        submitNextRow: function(rows, total, pos, saved) {
            total = total || rows.length;
            pos = pos || 1;
            saved = saved || 0;

            if (!rows.length) {
                return this.onSubmitComplete(total, saved);
            }

            // Update the table mask
            this.updateMask(
                this.$('#user-import-summary'),
                'Creating user ' + pos + ' of ' + (rows.length + pos - 1)
            );

            row = rows.pop();
            row.save().then(_.bind(function(res) {
                if (res && res.result.success > 0) {
                    this.user_rows = _.without(this.user_rows, row);
                    row.remove();
                    saved++;
                } else {
                    var name = row.model.firstname + ' ' + row.model.lastname
                    $('#growls').notify("create", "warning-template", {
                        title: 'Error creating user: ' + name,
                        text: res.result.errors.join('\n<br />')
                    });
                }
                this.submitNextRow(rows, total, pos + 1, saved);
            }, this));
        },

        onSubmitComplete: function(total, saved) {
            // Show a total count of users saved
            this.$('#user-import-save-status')
                .text('Saved ' + saved + ' of ' + total + ' users')
                .show();

            // Unmask the table
            this.removeMask(this.$('#user-import-summary'));
            // Show the users that remain
            this.$('.user-import-row').show();
            // Re-enable submit button
            this.$('#user-import-submit').attr('disabled', false);

            _.each(this.user_rows, function(row) {
                row.recheck();
            });

            this.onRowChange();

            dom().verticalStretchList();

            this.getExistingUsers().done(_.bind(function() {
                _.each(this.user_rows, function(row) {
                    row.recheck();
                });
                this.onRowChange();
                dom().verticalStretchList();
            }, this));
        },

        onRowChange: _.throttle(function() {
            if (this.$('.error').length || !this.user_rows.length) {
                this.$('#user-import-submit').attr('disabled', "disabled");
            } else {
                this.$('#user-import-submit').attr('disabled', false);
            }

            dom().verticalStretchList();
        }, 1000),

        getExistingUsers: function(page, deferred) {
            var limit = 2000,
                page = page || 1,
                deferred = deferred || $.Deferred();

            if (page === 1) {
                this.$('#import-loading-users').show();
            }

            var data = {
                display: 'ajax',
                orderBy: '',
                filter: '',
                filterType: '',
                page: page,
                limit: limit,
                showInactive: 1,
                level: 'admin'
            };

            $.getJSON('/admin/accounts.json', data).done(
                _.bind(function(results) {
                    _.each(results.accounts, function(user) {
                        this.existing_users.push({
                            firstname: user.firstName,
                            lastname: user.lastName,
                            email: user.email.toLowerCase(),
                            username: (user.userName || '').toLowerCase(),
                        });
                    }, this);

                    if (results.navigation.next === 'enabled') {
                        this.getExistingUsers(page + 1, deferred);
                    } else {
                        this.$('#import-loading-users').hide();
                        deferred.resolve();
                    }
                }, this)
            );

            return deferred.promise();
        },
    });

    return UserImportFlyout;

})($, _, Backbone, Curriculog.UserImportFlyout || {});
